/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://fh1a9n8yc2.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "SspBackendApi",
            "endpoint": "https://gofr66xhh1.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "SspExternalApi",
            "endpoint": "https://9lnu7z9nzc.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        },
        {
            "name": "bpmnGen",
            "endpoint": "https://n5q25kwa73.execute-api.eu-central-1.amazonaws.com/production",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:7afa283f-cb32-4f39-81ef-7282b89b1f47",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_xMIIF4kA5",
    "aws_user_pools_web_client_id": "78rhmv87v8ijeme7l7j0o4rcdr",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "selfserviceportal-20240129105819-hostingbucket-production",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://d2bzptww0d73o3.cloudfront.net",
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "SspUserInfo_prod",
            "region": "eu-central-1"
        }
    ]
};


export default awsmobile;
